module.exports = __webpack_public_path__ + "img/ardr.2607f8f6.svg";